export const GPT_HEAD_DRUG_CLASSES_PAGE = `
// list of all breakpoints we are using in the ads
// size property corresponds to sizeMapping used in the ad slots
// mq property lists the mediaquery this size should be visible to
const adBreakpoints = {
  start: { size: 0, mq: '(max-width: 350px)' },
  xxs: { size: 350, mq: '(min-width: 350px) and (max-width: 370px)' },
  xs: { size: 370, mq: '(min-width: 370px) and (max-width: 386px)' },
  sm: { size: 386, mq: '(min-width: 386px) and (max-width: 450px)' },
  md: { size: 450, mq: '(min-width: 450px) and (max-width: 690px)' },
  lg: { size: 690, mq: '(min-width: 690px) and (max-width: 778px)' },
  xl: { size: 778, mq: '(min-width: 778px) and (max-width: 1030px)' },
  xxl: { size: 1030, mq: '(min-width: 1030px) and (max-width: 1380px)' },
  xxxl: {
    size: 1380,
    mq: '(min-width: 1380px) and (max-width: 1492px)',
  },
  xxxxl: {
    size: 1492,
    mq: '(min-width: 1492px) and (max-width: 1700px)',
  },
  end: { size: 1700, mq: '(min-width: 1700px)' },
}

// size mapping array to be filled later, but this way we can access it globally
var sizeMapping = {
  leftRight: null,
  top: null,
  inContent: null,
  anchor: null,
}
googletag.cmd.push(function () {
  // size mapping specifically for vertical ads used left & right
  sizeMapping.leftRight = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [300, 600],
        [300, 250],
        [160, 600],
      ]
    )
    .addSize([adBreakpoints.xxxxl.size, 0], [[160, 600]])
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the top
  // to make sure the top ads only impact a minimal vertical space
  sizeMapping.top = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all in content and bottom ads
  sizeMapping.inContent = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [970, 250],
        [970, 90],
        [980, 120],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize([adBreakpoints.md.size, 0], [[400, 300]])
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all anchor ads
  sizeMapping.anchor = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // defining the main static slots
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Classes/drug-classes-page_top',
      getAllAdSizes(sizeMapping.top),
      'div-gpt-ad-1694721278359-0'
    )
    .defineSizeMapping(sizeMapping.top)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Classes/drug-classes-page_bottom',
      getAllAdSizes(sizeMapping.inContent),
      'div-gpt-ad-1698260592851-0'
    )
    .defineSizeMapping(sizeMapping.inContent)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Classes/drug-classes-page_bottom-anchor',
      getAllAdSizes(sizeMapping.anchor),
      'div-gpt-ad-1698260625357-0'
    )
    .defineSizeMapping(sizeMapping.anchor)
    .addService(googletag.pubads())

  // targeting variables
  var placement_nameMeta = document.querySelector(
    "meta[property='placement_name']"
  )
  if (placement_nameMeta) {
    googletag
      .pubads()
      .setTargeting(
        'placement_name',
        placement_nameMeta.content.slice(0, 40)
      )
  }

  var aid_nameMeta = document.querySelector("meta[property='aid_name']")
  if (aid_nameMeta) {
    googletag
      .pubads()
      .setTargeting('aid_name', aid_nameMeta.content.slice(0, 40))
  }

  var environmentMeta = document.querySelector(
    "meta[property='environment']"
  )
  if (environmentMeta) {
    googletag
      .pubads()
      .setTargeting('environment', environmentMeta.content.slice(0, 40))
  }

  var logged_inMeta = document.querySelector("meta[property='logged_in']")
  if (logged_inMeta) {
    googletag
      .pubads()
      .setTargeting('logged_in', logged_inMeta.content.slice(0, 40))
  }

  googletag.pubads().enableSingleRequest()
  googletag.pubads().collapseEmptyDivs()
  googletag.pubads().setCentering(true);
  adSlotsBorder();
  googletag.enableServices()
})`;

export const DRUG_CLASSES_PAGE_VERTICAL_RIGHT_SIDE_ADS = sizeMapping => {
  return [
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_right-hand_1st',
      id: 'div-gpt-ad-1698259579797-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_right-hand_2nd',
      id: 'div-gpt-ad-1698260320549-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_right-hand_3rd',
      id: 'div-gpt-ad-1698260354410-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_right-hand_4th',
      id: 'div-gpt-ad-1698260386404-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_right-hand_5th',
      id: 'div-gpt-ad-1698260559295-0',
      size: sizeMapping
    }
  ];
};

export const DRUG_CLASSES_PAGE_VERTICAL_LEFT_SIDE_ADS = sizeMapping => {
  return [
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_left-hand_1st',
      id: 'div-gpt-ad-1698259429425-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_left-hand_2nd',
      id: 'div-gpt-ad-1698259467289-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_left-hand_3rd',
      id: 'div-gpt-ad-1698259497557-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_left-hand_4th',
      id: 'div-gpt-ad-1698259525050-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_left-hand_5th',
      id: 'div-gpt-ad-1698259552221-0',
      size: sizeMapping
    }
  ];
};

export const DRUG_CLASSES_PAGE_HORIZONTAL_ADS = sizeMapping => {
  return [
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_in-content-1st',
      id: 'div-gpt-ad-1698259269993-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_in-content-2nd',
      id: 'div-gpt-ad-1698259304907-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_in-content-3rd',
      id: 'div-gpt-ad-1698259338895-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_in-content-4th',
      id: 'div-gpt-ad-1698259369330-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Drug-Classes/drug-classes-page_in-content-5th',
      id: 'div-gpt-ad-1698259398711-0',
      size: sizeMapping
    }
  ];
};
